import axios from 'axios'
import config from '../../../config/local'

const ENDPOINTS = {
  CONFIG: '/configuration/trending',
  MARKET_TEMPLATES: '/configuration/template-markets',
}

class TrendingConfigurationService {
  constructor() {
    this.setHeaders();
  }

  setHeaders() {
    this.trendingAxiosClient = axios.create({
      headers: {
          'Authorization':  `Bearer ${localStorage.getItem('token')}`
      }
    });
  }
  
  async getConfig() {
    return await this.get(ENDPOINTS.CONFIG);
  }

  async getMarketTemplates() {
    return await this.get(ENDPOINTS.MARKET_TEMPLATES);
  }

  async save(newTranslation) {
    return await this.post(ENDPOINTS.CONFIG, newTranslation);
  }

  async post(url, data) {
    this.setHeaders()
    try {
      const response = await this.trendingAxiosClient.post(`${config.TRENDING_CONFIGURATION}${url}`, data)

      return response
    } catch(error) {
      throw error
    }
  }

  async get(url, data) {
    this.setHeaders()
    try {
      const response = await this.trendingAxiosClient.get(`${config.TRENDING_CONFIGURATION}${url}`, data)

      return response
    } catch(error) {
      throw error
    }
  }
}

export const trendingConfigurationService = new TrendingConfigurationService()
